import { render, staticRenderFns } from "./mhap.vue?vue&type=template&id=21e32e30&lang=pug"
import script from "./mhap.vue?vue&type=script&setup=true&lang=js"
export * from "./mhap.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports